import { render, staticRenderFns } from "./OrdersProductsCategoriesListFilters.vue?vue&type=template&id=31304d52&"
import script from "./OrdersProductsCategoriesListFilters.vue?vue&type=script&lang=js&"
export * from "./OrdersProductsCategoriesListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports